import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import LoadingSpinner from '@/components/common/LoadingSpinner'

const RETURN_TO_STORAGE_KEY = 'portal:returnTo'

export default function CallbackPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()

  useEffect(() => {
    const timer = setTimeout(() => {
      const returnTo = sessionStorage.getItem(RETURN_TO_STORAGE_KEY)
      if (returnTo) {
        sessionStorage.removeItem(RETURN_TO_STORAGE_KEY)
        window.location.href = returnTo
        return
      }
      navigate('/', { replace: true })
    }, 2000)

    return () => clearTimeout(timer)
  }, [navigate])

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <LoadingSpinner size="lg" />
      <p className="mt-4 text-gray-600">{t('app.authenticating')}</p>
    </div>
  )
}
